import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import TileCard from '@/src/components/common/Elements/Card/TileCard/TileCard';
import Tooltip from '@/src/components/common/Elements/Tooltip/Tooltip';
import { reorderList } from '@/src/helpers/object';

const Layout1 = ({
  onColumnChanged,
  isColumnChanged,
  type,
  projectId,
  icon,
  count,
  classes,
  title,
}) => {
  const dispatch = useDispatch();
  const tasks = useSelector((state) => state.processesTasks);

  // Executes on component mount only
  useEffect(() => {
    /* Update column changed indicator if preselected counter from "Dasboard" is "For Review" */
    if (tasks.counter && tasks.counter === 'forReview') {
      onColumnChanged(true);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  /* Handles smart filtering when task counters chip is selected */
  const chipSmartFilters = (value) => {
    /* If "For Review" chip is previously selected, revert all column ordering update */
    if (isColumnChanged) {
      dispatch({ type: 'UPDATE_TASKS_COLUMNS', columns: reorderList(tasks.columns, 6, 7) });
      onColumnChanged(false);
    }

    /* Handler for updating tasks statuses filters based on task couters chips */
    const filterStatus = (operator = 'equals', statuses = []) => {
      dispatch({
        type: 'SET_TASKS_FILTERS',
        column: 'status',
        filters: (tasks.filters.status || []).map((f) => {
          if (operator === 'equals') {
            if (statuses.indexOf(f.id) !== -1) {
              return { ...f, isActive: true };
            }

            return { ...f, isActive: !value };
          } else {
            if (value) {
              if (statuses.indexOf(f.id) !== -1) {
                return { ...f, isActive: false };
              }
            }

            return { ...f, isActive: true };
          }
        }),
      });
    };

    switch (type) {
      case 'today':
        filterStatus('not', ['Delayed', 'Completed']);
        break;
      case 'forReview':
        if (value) {
          dispatch({ type: 'UPDATE_TASKS_COLUMNS', columns: reorderList(tasks.columns, 6, 7) });
          onColumnChanged(true);
        }

        filterStatus('equals', ['Change Requested', 'For Review']);

        break;
      case 'forApproval':
        filterStatus('equals', ['Change Requested', 'For Approval', 'Approved']);
        break;
      case 'delayed':
        filterStatus('not', ['Active', 'Completed']);
        break;
    }
  };

  const handleClick = () => {
    if (type !== 'files') {
      if (tasks.counter === type) {
        dispatch({ type: 'SET_TASKS_COUNTER', counter: '' });
        chipSmartFilters(false);
      } else {
        dispatch({ type: 'SET_TASKS_COUNTER', counter: type });
        chipSmartFilters(true);
      }
    } else {
      window.location.replace(`/account#/projects/${projectId}/files`);
    }
  };

  return (
    <TileCard className={`counterElements ${type} ${tasks.counter === type ? 'active' : ''}`}>
      {/* eslint-disable-next-line jsx-a11y/click-events-have-key-events */}
      <a onClick={handleClick} data-tooltip-id={`${type}_tooltip`} tabIndex="0" role="button">
        <div className={`counterContainer layout1 ${classes}`}>
          <div className="titleIconContainer">
            <div className="iconContainer">
              {tasks.counter === type ? icon.active : icon.default}
            </div>
          </div>
          <div className="countContainer">
            <div className="countValue">
              <span>{count}</span>
            </div>
          </div>
        </div>
        <Tooltip id={`${type}_tooltip`} place="bottom" effect="solid">
          {title.layout1}
        </Tooltip>
      </a>
    </TileCard>
  );
};

Layout1.defaultProps = {
  icon: <i className="material-icons">description</i>,
  title: '',
  additionalStatus: '',
  count: 0,
  classes: '',
};

export default Layout1;
